export default "__VITE_ASSET__Dr$N7J6a__"